<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const isKeeSite = computed(() => (page.props.siteName || 'german') === 'kee');
</script>
<template>
    <div
        class="flex min-h-screen"
        :class="isKeeSite ? 'purple-theme' : 'defaultTheme'"
    >
        <main
            class="flex flex-col grow justify-center"
            role="main"
        >
            <slot />
        </main>
    </div>
</template>
